import {
  PacketModule,
  createPacketServices
} from "./chunk-4RWQRXUP.mjs";
import "./chunk-CDQIA6O3.mjs";
export {
  PacketModule,
  createPacketServices
};
